import { render } from "./EmailMessage.vue?vue&type=template&id=7f777cfb&scoped=true"
import script from "./EmailMessage.vue?vue&type=script&lang=js"
export * from "./EmailMessage.vue?vue&type=script&lang=js"

import "./EmailMessage.vue?vue&type=style&index=0&id=7f777cfb&scoped=true&lang=css"

import exportComponent from "/home/runner/work/GB-Frontend/GB-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f777cfb"]])

export default __exports__